import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'
import Icon from '@mdi/react'
import styled, { keyframes } from 'styled-components'

export const WLANListItemBody = styled.div`
  flex: 1;
  color: ${theme.colors.otterWarmBlack};
  max-width: initial;
  word-break: work;
  @media ${theme.devices.tabletMid} {
    word-break: normal;
  }
`
export const WLANListBtn = styled(CommonLinkButton)`
  display: flex;
`

export const WLANListRightBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 20px;
  max-width: 20px;
  gap: 15px;
  flex: 1;
  @media ${theme.devices.tabletMid} {
    word-break: normal;
    font-size: 10px;
  }
`

export const WLANListLeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.tabletMid} {
    word-break: normal;
    font-size: 10px;
  }
`

export const WLANListLeftBlockStatus = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0;
  gap: 10px;
  width: 50px;

  @media ${theme.devices.mobile} {
    flex: 0;
  }
`

export const WLANListLeftBlockPrimary = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;
  @media ${theme.devices.tabletMid} {
    word-break: normal;
    margin-left: 10px;
  }
`

export const WLANListIndicator = styled(Icon)``

export const WLANListIcon = styled(Icon)`
  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const WLANListRow = styled.div<{ hover?: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px 5px;
  position: relative;

  ${({ hover }) => (hover ? 'background:#eeeeee' : 'background:#ffffff')};

  @media ${theme.devices.tablet} {
    gap: 18px;

    ${WLANListLeftBlock} {
      align-items: center;
      flex-direction: row;
    }
  }
`

export const WLANSeparator = styled.div`
  height: 1px;
  background-color: ${theme.colors.lightGrey};
`

export const WLANHoverBox2 = styled.div`
  display: flex;
  z-index: 9;
  margin: 30px;
  background: #009938;
  display: none;
`

const wlanButtonsAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`

export const WLANCopyButton = styled(CommonLinkButton)`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 300;
  text-align: left;
  padding: 5px 0px 0px 10px;
`

export const WLANDeactivateButton = styled(CommonLinkButton)`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 300;
  text-align: left;
  padding: 5px 0px 0px 10px;
`

export const WLANDeleteButton = styled(CommonLinkButton)`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 300;
  text-align: left;
  padding: 5px 0px 0px 10px;
`

export const WLANNameHightlighted = styled.span`
  font-weight: 750;
`

export const WLANHoverBox = styled.div<{ editMode: boolean }>`
  display: ${(p) => (p && p.editMode ? 'flex' : 'none')};
  position: absolute;
  z-index: 3;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  min-width: 200px;
  height: 92px;
  right: 40;
  bottom: -px;
  padding: 4px;
  background: ${theme.colors.white};
  box-shadow: 0 4px 40px ${theme.colors.commonShadow};
  border-radius: 8px;
  animation-name: ${wlanButtonsAnimation};
  animation-duration: 0.2s;

  @media ${theme.devices.mobile} {
    right: 100;
    bottom: -36px;
  }
  @media ${theme.devices.mediumDesktop} {
    right: 0;
    bottom: -36px;
  }
`
